export default class AppUtils{

    public static isMobile:boolean = false;

    public static findIndexByKey(array:Array<any>, key:string, value:any) {
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return i;
            }
        }
        return -1;
    }

    public static getStoryIndex(props:any, storyId:string):number {
        //let i:number = AppUtils.findIndexByKey(props.storys, 'id', parseInt(props.storyId));
        let i:number = AppUtils.findIndexByKey(props.storys, 'id', parseInt(storyId));
        return i;
    }

    public static getChapterIndex(props:any, chapterId:string):number {
        //let i:number = AppUtils.findIndexByKey(props.storys, 'id', parseInt(props.storyId));
        let i:number = AppUtils.findIndexByKey(props.chapters, 'id', parseInt(chapterId));
        return i;
    }

    public static getDecisionIndex(decisions:Array<any>, props:any, decisionId:string):number {
        let i:number = AppUtils.findIndexByKey(decisions, 'id', parseInt(decisionId));
        //let i:number = AppUtils.findIndexByKey(decisions, 'id', parseInt(props.id));
        return i;
    }
}


// WEBPACK FOOTER //
// ./src/utils/AppUtils.ts